import React from 'react';
import { useAuthToken } from '../../utils/auth/useAuthToken';
import { useLimitedMode } from '../../utils/auth/useLimitedMode';
import { SocketContextPortalProvider } from '../../utils/socket/context/portalSocketContext';
import { SocketContextSentinelProvider } from '../../utils/socket/context/sentinelSocketContext';
import './AppLayout.scss';

const AppSocketContext: React.FC = ({ children }) => {
  const auth = useAuthToken();
  const { isLimited } = useLimitedMode();

  const effectiveAuthToken = React.useMemo(() => {
    if (isLimited) return undefined; // If in any limited access mode, do not provide an auth token to the socket provider.
    if (auth.isExpired === true) return undefined; // Wait for refresh
    return auth.value?.access.token;
  }, [auth.isExpired, auth.value?.access.token, isLimited]);

  return (
    <SocketContextSentinelProvider token={effectiveAuthToken}>
      <SocketContextPortalProvider token={effectiveAuthToken}>{children}</SocketContextPortalProvider>
    </SocketContextSentinelProvider>
  );
};

export default AppSocketContext;
